import { ItemRestraints } from '@core/shared/restraints';
export class MediaAssetMapRestraints extends ItemRestraints {
  canViewItem(item) {
    return true;
  }
  canCreateItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canToggleItem(item) {
    return false;
  }
  canUpdateItem(item, oldItem) {
    return false; // asset mappings will always be replaced instead of updated!
  }
  canRemoveItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
}